import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const PillWrapper = styled.div`
  border-radius: 5px;
  background-color: ${props => props.bodyColor};
  border: 2px solid ${props => props.lipColor};
`;

const PillColorStrip = styled.div`
  width: 10%;
`;

const PillTextsContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const PillTitle = styled.div`
  font-size: 0.875rem;
  font-weight: 700;
`;

const PillCount = styled.div`
  font-size: 2rem;
  font-weight: 700;
  padding: 4px;
`;

const StatBox = ({ label, percentage, total, lipColor, bodyColor }) => (
  <PillWrapper lipColor={lipColor} bodyColor={bodyColor}>
    <div className="d-flex justify-content-between" style={{ gap: 5 }}>
      <PillColorStrip>
        <div className="w-100 h-100" style={{ backgroundColor: lipColor }} />
      </PillColorStrip>
      <PillTextsContainer className="p-0">
        <PillTitle>{label}</PillTitle>
        <div
          style={{ fontSize: '0.875rem', fontWeight: 400, fontStyle: 'italic' }}
        >
          {percentage}
        </div>
      </PillTextsContainer>
      <PillCount>{total}</PillCount>
    </div>
  </PillWrapper>
);

StatBox.propTypes = {
  label: PropTypes.string.isRequired,
  percentage: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  lipColor: PropTypes.string.isRequired,
  bodyColor: PropTypes.string.isRequired
};

export default StatBox;
